import {useState, useEffect} from 'react';

const useScrollPosition = () => {
    const [scrollPosition, setScrollPosition] = useState<number>(0);

    useEffect(() => {
        const updateScrollPosition = () => {
            setScrollPosition(window.scrollY); // window.scrollY returns the vertical scroll position
        };

        // Attach scroll event listener to the window
        window.addEventListener('scroll', updateScrollPosition);

        // Set the initial scroll position
        updateScrollPosition();

        // Cleanup event listener when component unmounts
        return () => {
            window.removeEventListener('scroll', updateScrollPosition);
        };
    }, []);

    return scrollPosition;
};

export default useScrollPosition;
